define("Convergence.ShopByCatBrand.ShopByCatBrand.Collection", [
    "Backbone",
    "Convergence.ShopByCatBrand.ShopByCatBrand.Model",
    "Utils",
], function (Backbone, ShopByCatBrandModel, Utils) {
    return Backbone.Collection.extend({
        model: ShopByCatBrandModel,
        url: Utils.getAbsoluteUrl(
            getExtensionAssetsPath("services/ShopByCatBrand.Service.ss")
        ),
        parse: function parse(response) {
            // console.log(response);
            // if (!_.isUndefined(response.totalRecordsFound)) {
            //     this.totalRecordsFound = response.totalRecordsFound;
            //     this.BuyersDetails = response.BuyersDetails;
            //     return response.itemResult;
            // }
            return response;
        },
    });
});
